import { useQuery } from "convex/react";
import { api } from "../convex/_generated/api";

/**
 * Runtime toggle for Disgo Passes sourced from Convex feature flags.
 * Defaults to `false` while loading and when missing.
 */
export function useDisgoPassesEnabled() {
  const isEnabled = useQuery(api.featureFlags.getDisgoPassesEnabled);
  return isEnabled ?? false;
}
